import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getComunas = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/comunas?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getComunasOnBoard = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/comunas/onboard?empresa=67fb199c799c1b69ec40fa38`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearComuna = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/comunas', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateComuna = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/comunas/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteComuna = (Id) => Axios.delete(`/comunas/${Id}`);
